import { useMutation } from '@tanstack/react-query';

import { getFaireVersement } from '@/services/getFaireVersement/getFaireVersement';
import { log } from '@/utils/functions/logger/logger';

export const useFaireVersement = () => {
  return useMutation({
    mutationFn: getFaireVersement,

    onError: (error) => {
      log.error(`useFaireVersement failed: ${error}`);
    },
  });
};
